import { type StyleProp, type TextStyle } from 'react-native';
import { StyleSheet as ReactNativeStyleSheet } from 'react-native-unistyles';
import type { LucideIcon, LucideProps } from 'lucide-react-native';
import { theme } from '@/theme';

type IconProps = LucideProps & {
  as: LucideIcon;
  style?: StyleProp<TextStyle>;
};

function Icon({ as: IconComponent, style, color, size = 14, ...props }: IconProps) {
  const flattenedStyle = (ReactNativeStyleSheet.flatten(style) ?? {}) as TextStyle & {
    width?: number;
  };

  return (
    <IconComponent
      color={flattenedStyle?.color ?? color ?? theme.colors.text}
      size={
        typeof flattenedStyle?.fontSize === 'number'
          ? flattenedStyle.fontSize
          : typeof flattenedStyle?.width === 'number'
            ? flattenedStyle.width
            : size
      }
      {...props}
    />
  );
}

export { Icon };
